import { render, staticRenderFns } from "./RoomCallCamStudyP2P.vue?vue&type=template&id=28278e7d&scoped=true&"
import script from "./RoomCallCamStudyP2P.vue?vue&type=script&lang=js&"
export * from "./RoomCallCamStudyP2P.vue?vue&type=script&lang=js&"
import style0 from "./RoomCallCamStudyP2P.vue?vue&type=style&index=0&id=28278e7d&lang=scss&"
import style1 from "./RoomCallCamStudyP2P.vue?vue&type=style&index=1&id=28278e7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28278e7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28278e7d')) {
      api.createRecord('28278e7d', component.options)
    } else {
      api.reload('28278e7d', component.options)
    }
    module.hot.accept("./RoomCallCamStudyP2P.vue?vue&type=template&id=28278e7d&scoped=true&", function () {
      api.rerender('28278e7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/p2p/RoomCallCamStudyP2P.vue"
export default component.exports